var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChemistryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48.3602,
    height: 48.3602,
    rx: 24.1801,
    fill: "#2AAC7E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9212_4859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4481 10.565C26.4481 10.6396 26.4338 10.7134 26.406 10.7822C26.3782 10.8511 26.3374 10.9136 26.2861 10.9662C26.2347 11.0188 26.1738 11.0605 26.1067 11.0888C26.0397 11.1172 25.9678 11.1316 25.8953 11.1314V30.5521H22.1027V11.1314C21.9568 11.1314 21.8168 11.0718 21.7137 10.9657C21.6105 10.8596 21.5525 10.7157 21.5525 10.5657C21.5525 10.4157 21.6105 10.2718 21.7137 10.1657C21.8168 10.0596 21.9568 10 22.1027 10H25.8953C25.9678 9.99958 26.0396 10.0139 26.1066 10.0421C26.1737 10.0703 26.2346 10.1118 26.286 10.1643C26.3374 10.2169 26.3781 10.2793 26.406 10.3481C26.4338 10.4168 26.4481 10.4906 26.4481 10.565Z",
    fill: "#E0DBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6532 10.565C25.6532 10.715 25.5954 10.8589 25.4923 10.965C25.3893 11.0712 25.2495 11.131 25.1036 11.1314V30.5521H22.1027V11.1314C21.9568 11.1314 21.8168 11.0718 21.7137 10.9657C21.6105 10.8596 21.5525 10.7157 21.5525 10.5657C21.5525 10.4157 21.6105 10.2718 21.7137 10.1657C21.8168 10.0596 21.9568 10 22.1027 10H25.1036C25.2494 10 25.3892 10.0595 25.4923 10.1655C25.5953 10.2715 25.6532 10.4152 25.6532 10.565Z",
    fill: "#E0DBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 30.8029C30.9987 32.3001 30.5427 33.7596 29.6958 34.9776C28.8489 36.1956 27.6532 37.1115 26.2756 37.5973C24.8981 38.0831 23.4073 38.1147 22.0115 37.6876C20.6156 37.2605 19.3843 36.3961 18.4893 35.215C17.5942 34.0339 17.0802 32.595 17.0189 31.0991C16.9576 29.6032 17.3521 28.1249 18.1472 26.8706C18.9424 25.6162 20.0987 24.6484 21.4547 24.1021C22.8106 23.5558 24.2986 23.4584 25.7111 23.8233C27.2227 24.2152 28.5639 25.1146 29.5219 26.3789C30.48 27.6433 31.0002 29.2002 31 30.8029Z",
    fill: "#E0DBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4205 30.803C30.4205 32.5534 29.7441 34.2322 28.5401 35.4699C27.3362 36.7077 25.7032 37.403 24.0006 37.403C22.2979 37.403 20.665 36.7077 19.461 35.4699C18.2571 34.2322 17.5807 32.5534 17.5807 30.803C17.5807 30.6926 17.5807 30.5815 17.5877 30.4731C17.6226 29.7451 17.7748 29.0281 18.0382 28.3514H29.9617C30.2252 29.0281 30.3772 29.7451 30.4116 30.4731C30.4186 30.5815 30.4205 30.6926 30.4205 30.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4136 30.4731C30.3518 32.1791 29.6491 33.7941 28.4532 34.9786C27.2573 36.1631 25.6613 36.8249 24.0007 36.8249C22.34 36.8249 20.7441 36.1631 19.5482 34.9786C18.3523 33.7941 17.6496 32.1791 17.5878 30.4731C17.6227 29.7451 17.7749 29.0281 18.0383 28.3514H29.9618C30.2259 29.028 30.3786 29.745 30.4136 30.4731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 28.8543C27.2936 28.8543 29.9631 28.6291 29.9631 28.3514C29.9631 28.0736 27.2936 27.8484 24.0006 27.8484C20.7077 27.8484 18.0382 28.0736 18.0382 28.3514C18.0382 28.6291 20.7077 28.8543 24.0006 28.8543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 30.8029C30.9995 31.9831 30.7168 33.1451 30.1768 34.1865C29.6367 35.228 28.8559 36.1169 27.903 36.7751C26.9502 37.4333 25.8545 37.8406 24.7125 37.961C23.5705 38.0814 22.4172 37.9113 21.3542 37.4657C26.4074 38.9968 31.6646 34.9704 30.6867 29.9008C29.9287 25.9737 26.9945 24.3524 25.7111 23.822C27.2228 24.2142 28.564 25.1138 29.5221 26.3784C30.4801 27.6429 31.0002 29.2 31 30.8029Z",
    fill: "#E0DBDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M22.1027 24.643C21.3142 24.5895 18.9893 26.5498 18.46 29.4409C17.9473 32.238 18.9493 34.4275 20.0485 34.1342C21.1477 33.8409 20.0892 31.085 20.945 28.561C21.63 26.5439 23.0145 24.7044 22.1027 24.643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M22.6327 11.4658C22.409 11.4658 22.3417 23.2818 22.6327 23.2818C22.9237 23.2818 22.8563 11.4658 22.6327 11.4658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1028 11.1313H25.1037L25.5923 11.4664L22.1028 11.1313Z",
    fill: "#E0DBDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9212_4859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 28,
    fill: "white",
    transform: "translate(17 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemistryIcon);
export default __webpack_public_path__ + "static/media/ChemistryIcon.a3e1c3a25d1d9582af413fc39bd64024.svg";
export { ForwardRef as ReactComponent };